/*
 *
 * PosGenericPopUp
 *
 * @version 1.0.0
 * @author Serafino Busalacchi
 * @since 03-Apr-2026
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  acceptPrivacy: <PortalMessage id='t.app.pointOfSale.modal.action.acceptPrivacy' defaultMessage='Accept' />,
  activeLabel: <PortalMessage id='t.app.pointOfSale.modal.activeLabel' defaultMessage='Disabled' />,
  addLanguage: <PortalMessage id='t.app.pointOfSale.modal.addLanguage' defaultMessage='Add language' />,
  cancel: <PortalMessage id='t.app.pointOfSale.modal.action.cancel' defaultMessage='Cancel' />,
  confirm: <PortalMessage id='t.app.pointOfSale.modal.action.confirm' defaultMessage='Confirm' />,
  contactModalTitle: <PortalMessage id='t.app.pointOfSale.modal.contactTitle' defaultMessage='Customer Care' />,
  create: <PortalMessage id='t.app.pointOfSale.modal.action.create' defaultMessage='Create' />,
  defaultPolicyRestricted: <PortalMessage id='t.app.pointOfSale.modal.defaultPolicyRestricted' defaultMessage='The default Privacy Policy cannot be modified.' />,
  emailCustomerCare: <PortalMessage id='t.app.pointOfSale.modal.emailCustomerCare' defaultMessage='Email Address' />,
  emailCustomerCareInvalid: <PortalMessage id='t.app.paybylink.request.validator.validEmail' defaultMessage='Enter a valid email' />,
  etsModalTitle: <PortalMessage id='t.app.pointOfSale.modal.etsTitle' defaultMessage='ETS Data' />,
  generalInformations: <PortalMessage id='t.app.pointOfSale.modal.generalInformations' defaultMessage='General Information' />,
  inactiveLabel: <PortalMessage id='t.app.pointOfSale.modal.inactiveLabel' defaultMessage='Enabled' />,
  mobilePhoneCustomerCare: <PortalMessage id='t.app.pointOfSale.modal.mobilePhoneCustomerCare' defaultMessage='Contact Mobile Phone' />,
  modalTitle: <PortalMessage id='t.app.pointOfSale.modal.title' defaultMessage='Pos Modal Title' />,
  privacyModalTitle: <PortalMessage id='t.app.pointOfSale.modal.privacyTitle' defaultMessage='Privacy Policy' />,
  privacyName: <PortalMessage id='t.app.pointOfSale.modal.privacyName' defaultMessage='Name privacy policy' />,
  privacyText: <PortalMessage id='t.app.pointOfSale.modal.privacyText' defaultMessage='Custom Privacy Policy Text' />,
  privacyToggleSubtitle: <PortalMessage id='t.app.pointOfSale.modal.privacyToggleSubtitle' defaultMessage='Activating this Privacy Policy will deactivate the currently active one.' />,
  privacyToggleTitle: <PortalMessage id='t.app.pointOfSale.modal.privacyToggleTitle' defaultMessage='Enable/Disable Privacy Policy' />,
  removeLanguage: <PortalMessage id='t.app.pointOfSale.modal.removeLanguage' defaultMessage='Delete' />,
  runtsRegistrationCode: <PortalMessage id='t.app.pointOfSale.modal.runtsRegistrationCode' defaultMessage='RUNTS registration number' />,
  runtsRegistrationDate: <PortalMessage id='t.app.pointOfSale.modal.runtsRegistrationDate' defaultMessage='RUNTS registration date' />,
  saveWebsite: <PortalMessage id='t.app.pointOfSale.modal.action.saveWebsite' defaultMessage='Confirm' />,
  selectLanguage: <PortalMessage id='t.app.pointOfSale.modal.selectLanguage' defaultMessage='Select Language' />,
  websiteModalSubtitle: <PortalMessage id='t.app.pointOfSale.modal.websiteSubtitle' defaultMessage='Enter the address of your website or the social media page linked to XPay. <strong>The URL is required to complete service activation.</strong> Once entered, it cannot be modified directly in the portal; please contact customer support to request changes.' />,
  websiteModalTitle: <PortalMessage id='t.app.pointOfSale.modal.websiteTitle' defaultMessage='Insert the website URL' />,
  websiteUrlLabel: <PortalMessage id='t.app.pointOfSale.modal.websiteUrl' defaultMessage='Website URL' />,
  websiteUrlInvalid: <PortalMessage id='t.app.pointOfSale.modal.websiteUrlInvalid' defaultMessage='Enter a valid URL' />,
}

export const messages = defineMessages({
  bs: {
    id: 't.app.profile.language.bs',
    defaultMessage: 'Bosanski'
  },
  it: {
    id: 't.app.profile.language.it',
    defaultMessage: 'Italiano'
  },
  el: {
    id: 't.app.profile.language.el',
    defaultMessage: 'Ελληνικά'
  },
  en: {
    id: 't.app.profile.language.en',
    defaultMessage: 'English'
  },
  sk: {
    id: 't.app.profile.language.sk',
    defaultMessage: 'Slovenčina'
  },
  sl: {
    id: 't.app.profile.language.sl',
    defaultMessage: 'Slovenščina'
  },
  cs: {
    id: 't.app.profile.language.cs',
    defaultMessage: 'Čeština'
  },
  hu: {
    id: 't.app.profile.language.hu',
    defaultMessage: 'Magyar'
  },
  ro: {
    id: 't.app.profile.language.ro',
    defaultMessage: 'Română'
  },
  de: {
    id: 't.app.profile.language.de',
    defaultMessage: 'Deutsch'
  },
  pl: {
    id: 't.app.profile.language.pl',
    defaultMessage: 'Polski'
  },
  hr: {
    id: 't.app.profile.language.hr',
    defaultMessage: 'Hrvatski'
  },
  sq: {
    id: 't.app.profile.language.sq',
    defaultMessage: 'Shqip'
  },
  sr: {
    id: 't.app.profile.language.sr',
    defaultMessage: 'Serbian'
  },
  description: {
    id: 't.app.accessibility.profile.language.description.ariaLabel',
    defaultMessage: 'Select the language that you prefer'
  },
  websiteUrlPlaceholder: {
    id: 't.app.pointOfSale.modal.websiteUrlPlaceholder',
    defaultMessage: 'Insert website URL'
  },
  validPhoneNumber: {
    id: 't.app.paybylink.request.other.info.validator.phoneNumber',
    defaultMessage: 'it is a numeric field and can be between 6 and 15 digits.'
  }
})

export default formattedMessage
